<template>
  <div class="min-h-screen relative overflow-hidden">
    <!-- Background Image with Dark Transparent Overlay -->
    <!-- <div
      class="absolute inset-0 bg-cover bg-center bg-no-repeat"
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    ></div> -->
    <div class="absolute inset-0 bg-gray-200 bg-opacity-80"></div>

    <!-- Content -->
    <div class="relative z-10 min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8">
      <div class="w-full max-w-3xl">
        <!-- Card -->
        <div>
          <!-- Admin Logo -->
          <div class="text-center mb-8">
            <img
              :src="logoImage"
              alt="Admin Portal"
              class="mx-auto w-96 object-contain"
            />
            <p class="mt-8 mb-6 text-2xl font-medium text-zinc-700">
              Sign In to Manage the System
            </p>
          </div>

          <!-- Error Message -->
          <div v-if="error" class="mb-6 rounded-md bg-red-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <p class="text-sm text-red-700">{{ error }}</p>
              </div>
            </div>
          </div>

          <!-- Login Form -->
          <form @submit.prevent="handleAdminLogin" class="space-y-6 bg-white p-16 rounded-2xl">
            <!-- Email -->
            <div>
              <input
                id="email"
                v-model="email"
                type="email"
                placeholder="Admin Email Address*"
                required
                class="w-full px-8 py-5 bg-transparent border-2 border-zinc-200 rounded-lg focus:outline-none placeholder-zinc-700 placeholder:text-lg text-zinc-700 focus:border-blue-600 transition-colors"
              />
            </div>

            <!-- Password -->
            <div class="relative">
              <input
                id="password"
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Password*"
                required
                class="w-full px-8 py-5 pr-14 bg-transparent border-2 border-zinc-200 rounded-lg focus:outline-none placeholder-zinc-700 placeholder:text-lg text-zinc-700 focus:border-blue-600 transition-colors"
              />
              <button
                type="button"
                @click="showPassword = !showPassword"
                class="absolute inset-y-0 right-0 pr-4 flex items-center text-zinc-500 hover:text-zinc-700 transition-colors"
              >
                <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                  <path d="M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" />
                  <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" />
                  <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                  <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                  <path fill-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z" clip-rule="evenodd" />
                </svg>
              </button>
            </div>

            <!-- Submit Button -->
            <div class="flex justify-center">
              <button
                type="submit"
                :disabled="loading"
                class="px-16 py-3 font-medium text-xl rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {{ loading ? 'Signing in...' : 'Sign In' }}
              </button>
            </div>
          </form>

          <!-- Back to Customer Login -->
          <div class="text-center mt-8">
            <p class="text-xl text-zinc-700">
              Not an admin?
              <a
                href="#"
                @click.prevent="goToCustomerLogin"
                class="font-medium text-blue-600 hover:text-blue-700 hover:underline"
              >
                Customer Login
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import backgroundImage from '@/assets/staticbg.png'
import logoImage from '@/assets/main_logo.png'

const router = useRouter()
const authStore = useAuthStore()

// Form state
const email = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')
const showPassword = ref(false)

const handleAdminLogin = async () => {
  try {
    loading.value = true
    error.value = ''

    // Validate input
    if (!email.value || !password.value) {
      throw new Error('Please enter both email and password')
    }

    // Call admin login API
    await authStore.adminLogin({
      email: email.value,
      password: password.value
    })

    // Redirect handled by auth store

  } catch (err: any) {
    console.error('Admin login error:', err)

    if (err.response?.data?.message) {
      error.value = err.response.data.message
    } else if (err.message) {
      error.value = err.message
    } else {
      error.value = 'Admin login failed. Please try again.'
    }
  } finally {
    loading.value = false
  }
}

const goToCustomerLogin = () => {
  router.push('/brands')
}
</script>

<style scoped>
/* Custom focus styles for inputs */
input:focus {
  outline: none;
}
</style>

